module.exports = __webpack_public_path__ + "static/Inter-Regular-47e70f6ff021c610674288ca517294f4.woff2";